<template>
  <div class="all_customer_style">
    <div class="fixed_search" :style="searchHeight">
      <Form ref="formValidate" :model="formValidate" class="form_submit_style">
        <FormItem v-for="(item,index) in formValidate.searchList" :key="index">
          <Input v-if="item.type=='text'|| item.type=='textarea'" :title="item.customName" :placeholder="item.customName" v-model="item.customValue"/>

          <el-date-picker  v-model="item.customValue" unlink-panels type="datetimerange" :start-placeholder="'开始'+item.customName" :end-placeholder="'结束'+item.customName"  :title="item.customName" align="left" :default-time="['00:00:00', '23:59:59']"
                           :editable="editable" :picker-options="pickerOptions"  format="yyyy-MM-dd HH:mm:ss"  value-format="yyyy-MM-dd HH:mm:ss" v-if="item.type=='datetime'"></el-date-picker>

          <Select v-if="item.type=='select' || item.type=='radio'" :placeholder="item.customName" :title="item.customName" clearable  v-model="item.customValue">
            <Option v-for="(option, index) in item.list" :value="option.id" :key="index">{{option.dictValue}}</Option>
          </Select>

          <Select v-if="item.type=='checkbox'" :placeholder="item.customName" class="multiple_search" :title="item.customName" clearable multiple :max-tag-count="2" v-model="item.customValue">
            <Option v-for="(option, index) in item.list" :value="option.id" :key="index">{{option.dictValue}}</Option>
          </Select>

          <el-cascader clearable  v-if="item.type=='cascade'" v-model="item.customValue" :placeholder="item.customName" :title="item.customName" :options="item.list" :props="{ expandTrigger: 'hover' }"></el-cascader>

          <Input v-if="item.type=='number'" type="number" placeholder="只能输入数字" :title="item.customName" v-model="item.customValue"/>
        </FormItem>
        <FormItem class="fixed_operation_btn senior_search">
          <el-popover  placement="bottom" width="400" trigger="click" v-if="formValidate.seniorList.length>0" :visible-arrow="visible">
            <div v-for="(item,index) in formValidate.seniorList" :key="index">
              <Input v-if="item.type=='text'|| item.type=='textarea'" :title="item.customName" :placeholder="item.customName" v-model="item.customValue"/>

              <el-date-picker  v-model="item.customValue" unlink-panels type="datetimerange" :start-placeholder="'开始'+item.customName" :end-placeholder="'结束'+item.customName"  :title="item.customName" align="left" :default-time="['00:00:00', '23:59:59']"
                               :editable="editable" :picker-options="pickerOptions"  format="yyyy-MM-dd HH:mm:ss"  value-format="yyyy-MM-dd HH:mm:ss" v-if="item.type=='datetime'"></el-date-picker>

              <Select v-if="item.type=='select' || item.type=='radio'" :placeholder="item.customName" :title="item.customName" clearable  v-model="item.customValue">
                <Option v-for="(option, index) in item.list" :value="option.id" :key="index">{{option.dictValue}}</Option>
              </Select>

              <el-cascader clearable  v-if="item.type=='cascade'" v-model="item.customValue" :placeholder="item.customName" :title="item.customName" :options="item.list" :props="{ expandTrigger: 'hover' }"></el-cascader>

              <Select v-if="item.type=='checkbox'" class="multiple_style"  :placeholder="item.customName" :title="item.customName" clearable multiple :max-tag-count="2" v-model="item.customValue">
                <Option v-for="(option, index) in item.list" :value="option.id" :key="index">{{option.dictValue}}</Option>
              </Select>

              <Input v-if="item.type=='number'" type="number" placeholder="只能输入数字" :title="item.customName" v-model="item.customValue"/>
            </div>
            <el-button slot="reference"><div class="btn_font_search">高级搜索</div></el-button>
          </el-popover>
          <Button type="primary" class="search_btn" style="margin-left: 10px" @click="initSearch()">查询</Button>
          <Button type="primary" style="margin-left: 10px" class="search_btn reset_btn"  @click="handleReset()">重置</Button>
          <Button type="error" style="margin-left: 10px" class="search_btn" v-if="roleList['4_2-1']"  @click="batchDeleteOperate('我的工作台=>待回访客户=>批量删除','4_2-1')">批量删除</Button>
        </FormItem>
      </Form>
    </div>
    <div class="fixed_table">
      <el-table :data="contentList" style="width: 100%" :height="tableHeight" class="element_table" stripe ref="selection"  :class="{'tableClass':tableClass}" @cell-click="openCallScreen" :cell-class-name="returnClassName" @selection-change="getSelectedId">
        <el-table-column type="selection" width="50" align="center"> </el-table-column>
        <el-table-column v-for="(item,index) in fieldList" align="center" :show-overflow-tooltip='true' :type="item.type" :key="index" :fixed="item.fixed"  :prop="item.key" :label="item.title" :width="item.width">
          <template slot="header" slot-scope="scope">
              <el-tooltip  placement="top">
                <span style="overflow:hidden;text-overflow:ellipsis;white-space: nowrap;width: 100%;display: block;">{{item.title}}</span>
                <div slot="content" >
                  <span>{{item.title}}</span>
                </div>
              </el-tooltip>
          </template>
          <template slot-scope="scope" >
            <!-- 附件 -->
            <el-tooltip placement="top" effect="light" v-if="item.customColSource != undefined && item.customColSource.indexOf('file') != -1 && scope.row[item.key] != '' && scope.row[item.key] != undefined">

              <span style="color: #2d8cf0;" v-show="JSON.parse(scope.row[item.key]).length > 0">共{{JSON.parse(scope.row[item.key]).length}}个附件</span>
              <div slot="content">
                <p v-for="(fileItem,fileIndex) in JSON.parse(scope.row[item.key])" :key="fileIndex">
                  <a style="font-size:14px;color: blue;" :href="baseURL+'common/downloadFile.json?type=0&addr='+fileItem.downloadAddr">附件{{fileIndex+1}}：{{fileItem.description}}</a>
                </p>
              </div>
            </el-tooltip>

            <!-- 其他 -->
            <span v-else>{{scope.row[item.key]}}</span>
          </template>
        </el-table-column>
        <el-table-column  fixed="right" label="操作" width="150" align="center" v-if="contentList.length>0">
          <template slot-scope="scope">
            <el-button @click="deleteOperate('我的工作台=>待回访客户=>删除','4_2-2',scope.row.id)" v-if="roleList['4_2-2']" type="text" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <Spin size="large" fix v-if="spinShow"><Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
    </div>
    <div class="page_style">
      <Page :total="total" size="small" :page-size='pageSize' :current='currentPage' :page-size-opts="pageSizeList" show-total show-sizer  @on-change="changeCurrent" @on-page-size-change="changeSize"/>
      <div style="padding-top: 2px;">跳至</div><Input class="show-elevator" v-model="speedChangePage" @on-blur="handleCurrentPage"/><div style="padding-top: 2px;">页</div>
    </div>
    <deleteTitlePop @closeTitlePop="closeTitlePop" :publicTitle="deleteTitle" :showTitlePop="showTitlePop"></deleteTitlePop>
    <publicDialerPage  @closePublicDialerPage="closePublicDialerPage" :showPublicDialer="showPublicDialer"  :callUpPhone="callUpPhone" ></publicDialerPage>
    <PublicSendMessage  @closeSendMessage="closeSendMessage" :showSendMessage="showSendMessage"  :callUpPhone="callUpPhone" ></PublicSendMessage>
  </div>
</template>

<script>
  import {publicFunClass} from '@/components/js/PublicFunClass.js'
  import {customerPublic} from '@/components/js/CustomerPublic.js'
  import deleteTitlePop from '@/components/customerMange/DeleteTitlePop.vue'
  import publicDialerPage from '@/components/login/PublicDialerPage.vue'
  import PublicSendMessage from '@/components/login/PublicSendMessage.vue'
  export default {
    name: "WaitHandleCall",
    mixins:[publicFunClass,customerPublic],
    components:{
      deleteTitlePop,
      publicDialerPage,
      PublicSendMessage
    },
    props:{
      pageCode:String
    },
    data: function () {
      return {
        showPageCount:0,
        formValidate:{"searchList":[],"seniorList":[],},
        configInfo: JSON.parse(localStorage.getItem("configInfo")),
        searchHeight:{'height':''},
        spinShow: true,
        visible: true,
        showTitlePop: false,
        showPublicBtn:false,
        tableClass: true,
        tableHeight:600,
        total: 0,
        pageSizeList: [10, 20, 30, 40, 50, 100, 200],
        currentPage: 1,
        speedChangePage: 1,
        pageSize: 20,
        tableCount:0,
        roleList: JSON.parse(localStorage.getItem("roleList")),
        fieldList: [],
        contentList: [],
        checkIds:[],
        deleteUrl:'mywork/deleteCallback.json',
        deleteTitle:'批量删除待回访客户',
        editable:false,
        queryParam: null,
      }
    },
    methods:{
      messageOrPhone:function(phone,id){
        let that=this;
        if(phone.indexOf("(")!=-1){
          phone=phone.substring(0,phone.indexOf("("));
        }
        let signinStatus=localStorage.getItem("signinStatus");
        let sendMessageFlag=localStorage.getItem("sendMessageFlag");
        that.callUpPhone=phone;
        if(!phone) {
          return false;
        }
        if(sendMessageFlag=='0'){
          if(signinStatus=='0'){
            this.$Message.info("请先签入");
            return false;
          }
          let cusData="callback_"+id;
          this.$emit("openCallPhone",true,phone,'1',cusData);
          return false;
        }
        this.$confirm('请选择发送短信或者拨打电话', '提示', {
          distinguishCancelAndClose: true,
          confirmButtonText: '拨打电话',
          cancelButtonText: '发送短信'
        }).then(() => {
          if(signinStatus=='0'){
            that.$Message.info("请先签入");
            return false;
          }
          if(phone){
            let cusData="callback_"+id;
            that.$emit("openCallPhone",true,phone,'1',cusData);
          }
        })
          .catch(action => {
            if(action === 'cancel'){
              that.showSendMessage=true;
            }
          });
      },
      openCallScreen:function(row, column){
        if(column.property){
          let phone=row[column.property];
          if(column.property.indexOf("Hide")!=-1){
            phone=row[column.property.substring(0,column.property.length-4)]
          }
          if(column.property.toLowerCase().indexOf("telephone")!=-1 && column.property.indexOf('Address')==-1){
            this.messageOrPhone(phone,row.id);
            return;
          }
          if(column.property.toLowerCase().indexOf("phone")!=-1 && column.property.indexOf('telephoneOneAddress')==-1){
            this.messageOrPhone(phone,row.id);
            return;
          }
        }
      },
      returnClassName:function(event){
        if(event.column.property){
          if(event.column.property.toLowerCase().indexOf("telephone")!=-1 && event.column.property.indexOf("Address")==-1){
            return 'telephone'
          }
          if(event.column.property.toLowerCase().indexOf("phone")!=-1 && event.column.property.indexOf("Address")==-1){
            return 'telephone'
          }
        }
      },
      initSearch:function () {
        this.spinShow=true;
        let param={
          pageNum:this.currentPage,
          pageSize:this.pageSize,
          journalType:"null",
          menuId:"null"
        };
        this.speedChangePage=this.currentPage;
        this.getParam(this.formValidate,param);
        let url="mywork/callback.json";
        this.publicSearch(url,param,2);
      }
    },
    watch:{
      pageCode:function () {
        if(this.pageCode=='4_2' && this.showPageCount==0){
          this.showPageCount++;
          this.initSearch();
          this.handleScroll();
        }
      }
    }
  }
</script>

<style scoped lang="less">
</style>



// WEBPACK FOOTER //
// src/components/myWorkbench/WaitHandleCall.vue